module.exports = __webpack_public_path__ + "img/heading_uk.cd539912.svg";